module.exports = __webpack_public_path__ + "static/emptylist.fa24c6b3.png";